import { render, staticRenderFns } from "./LandsideFooter.vue?vue&type=template&id=0a17ee94&"
import script from "./LandsideFooter.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideFooter.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports